import {useSuspenseQuery} from '@tanstack/react-query';
import {prepareSearchParams} from 'shared';

import {api} from '@/lib/ky';
import {extractPagination} from '@/utils/extractPagination';

import {siteListSchema} from '../utils/schemas/site';

import {siteKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getSites = async (params: QueryParams = {}) => {
  const res = await api.get(`sites`, {
    searchParams: prepareSearchParams(params),
  });
  const data = await res.json();
  const pagination = extractPagination(res);
  return [siteListSchema.parse(data), pagination] as const;
};

export const useSites = (
  params?: QueryParams,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: siteKeys.list(params),
    queryFn: () => getSites(params),
  });
};
export const useSitesLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getSites;
type QueryParams = Parameters<typeof siteKeys.list>[0];
